import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Card, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { fetchIngestionFailureDetail } from "api/menu/hr/ingestion-failures/actions";

class IngestionFailureView extends Component {
    componentDidMount() {
        const { id } = this.props.match.params;
        this.props.fetchIngestionFailureDetail(id);
    }

    renderField = (label, value) => {
        return (
            <Row className="mb-3">
                <Col md={3}>
                    <strong>{label}:</strong>
                </Col>
                <Col md={9}>
                    {value !== null && value !== undefined ? value : <span className="text-muted">N/A</span>}
                </Col>
            </Row>
        );
    };

    renderJsonField = (label, jsonString) => {
        if (!jsonString) {
            return (
                <Row className="mb-3">
                    <Col md={3}>
                        <strong>{label}:</strong>
                    </Col>
                    <Col md={9}>
                        <span className="text-muted">N/A</span>
                    </Col>
                </Row>
            );
        }

        try {
            const parsed = JSON.parse(jsonString);
            return (
                <Row className="mb-3">
                    <Col md={3}>
                        <strong>{label}:</strong>
                    </Col>
                    <Col md={9}>
                        <pre style={{ 
                            backgroundColor: '#f5f5f5', 
                            padding: '10px', 
                            borderRadius: '4px',
                            maxHeight: '300px',
                            overflow: 'auto'
                        }}>
                            {JSON.stringify(parsed, null, 2)}
                        </pre>
                    </Col>
                </Row>
            );
        } catch (e) {
            return this.renderField(label, jsonString);
        }
    };

    render() {
        const { selectedFailure, detailLoading } = this.props;

        if (detailLoading) {
            return (
                <div className="dashboard">
                    <div className="text-center mt-5">
                        <FontAwesomeIcon icon="spinner" spin size="3x" />
                        <p className="mt-3">Loading ingestion failure details...</p>
                    </div>
                </div>
            );
        }

        if (!selectedFailure) {
            return (
                <div className="dashboard">
                    <h3>Ingestion Failure Not Found</h3>
                    <Link to="/hr/ingestion-failures" className="btn btn-primary mt-3">
                        <FontAwesomeIcon icon="arrow-left" className="mr-2" />
                        Back to List
                    </Link>
                </div>
            );
        }

        return (
            <div className="dashboard">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3>Ingestion Failure Details - ID: {selectedFailure.id}</h3>
                    <Link to="/hr/ingestion-failures" className="btn btn-secondary">
                        <FontAwesomeIcon icon="arrow-left" className="mr-2" />
                        Back to List
                    </Link>
                </div>

                <Card className="mb-4">
                    <Card.Header>
                        <h5 className="mb-0">Basic Information</h5>
                    </Card.Header>
                    <Card.Body>
                        {this.renderField("ID", selectedFailure.id)}
                        {this.renderField("Occurred (UTC)", new Date(selectedFailure.occurredUtc).toLocaleString())}
                        {this.renderField("Mailbox", selectedFailure.mailbox)}
                        {this.renderField("Message ID", selectedFailure.messageId)}
                        {this.renderField("Subject", selectedFailure.subject)}
                        {this.renderField("Has Attachments", selectedFailure.hasAttachments ? "Yes" : "No")}
                    </Card.Body>
                </Card>

                <Card className="mb-4">
                    <Card.Header>
                        <h5 className="mb-0">Error Details</h5>
                    </Card.Header>
                    <Card.Body>
                        {this.renderField("Validation Step", selectedFailure.validationStep)}
                        {this.renderField("Error Code", selectedFailure.errorCode)}
                        {this.renderField("Error Message", selectedFailure.errorMessage)}
                        {selectedFailure.exceptionText && (
                            <Row className="mb-3">
                                <Col md={3}>
                                    <strong>Exception Text:</strong>
                                </Col>
                                <Col md={9}>
                                    <pre style={{ 
                                        backgroundColor: '#ffebee', 
                                        padding: '10px', 
                                        borderRadius: '4px',
                                        maxHeight: '400px',
                                        overflow: 'auto',
                                        fontSize: '0.85rem',
                                        color: '#c62828'
                                    }}>
                                        {selectedFailure.exceptionText}
                                    </pre>
                                </Col>
                            </Row>
                        )}
                    </Card.Body>
                </Card>

                <Card className="mb-4">
                    <Card.Header>
                        <h5 className="mb-0">Parsed Information</h5>
                    </Card.Header>
                    <Card.Body>
                        {this.renderField("Parsed Job Title", selectedFailure.parsedJobTitle)}
                        {this.renderField("Parsed City", selectedFailure.parsedCity)}
                        {this.renderField("Parsed Province", selectedFailure.parsedProvince)}
                        {this.renderField("Job Posting ID", selectedFailure.jobPostingId)}
                        {this.renderField("Assigned To ID", selectedFailure.assignedToId)}
                        {this.renderField("Resume File ID", selectedFailure.resumeFileId)}
                        {this.renderField("SHA256 Hash", selectedFailure.sha256Hash)}
                    </Card.Body>
                </Card>

                {selectedFailure.additionalJson && (
                    <Card className="mb-4">
                        <Card.Header>
                            <h5 className="mb-0">Additional Data</h5>
                        </Card.Header>
                        <Card.Body>
                            {this.renderJsonField("Additional JSON", selectedFailure.additionalJson)}
                        </Card.Body>
                    </Card>
                )}
            </div>
        );
    }
}

IngestionFailureView.propTypes = {
    fetchIngestionFailureDetail: PropTypes.func.isRequired,
    selectedFailure: PropTypes.object,
    detailLoading: PropTypes.bool.isRequired,
    match: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    selectedFailure: state.ingestionFailures.selectedFailure,
    detailLoading: state.ingestionFailures.detailLoading
});

const mapDispatchToProps = dispatch => ({
    fetchIngestionFailureDetail: bindActionCreators(fetchIngestionFailureDetail, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(IngestionFailureView);

